// export const API_URL = "https://dev-api-aquacity.metatech.foundation/api";
export const API_URL = process.env.REACT_APP_API_URL